var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("BoutonAjoutProduit", {
        ref: "modalAjoutProduit",
        attrs: {
          fournisseurId: _vm.commandeFournisseur.fournisseurId,
          title:
            "Ajouter un article à la commande " +
            _vm.commandeFournisseur.commandeNom
        },
        on: {
          "ajouter-produit": function($event) {
            return _vm.ajouterArticle(_vm.commandeFournisseur, $event)
          }
        }
      }),
      _c("BoutonAjoutIncident", {
        ref: "modalAjoutIncidentGlobal",
        attrs: {
          idModal: "Global",
          optionsIncident: _vm.optionsIncidentGlobal,
          optionsTypesDeReclamations: _vm.optionsTypesDeReclamations
        },
        on: {
          incident: function($event) {
            _vm.ajouterIncident($event, _vm.commandeFournisseur)
            _vm.key++
          }
        }
      }),
      _c("BoutonAjoutIncident", {
        ref: "modalAjoutIncidentLigne",
        attrs: {
          size: "sm",
          idModal: "IncidentLigne",
          optionsIncident: _vm.optionsIncidentLigne,
          optionsTypesDeReclamations: _vm.optionsTypesDeReclamations
        },
        on: {
          incident: function($event) {
            return _vm.ajouterIncident($event, _vm.ligneSelectionnee)
          }
        }
      }),
      _c(
        "div",
        { key: _vm.key, staticClass: "container-fluid" },
        [
          _c("BarreActions", {
            attrs: { actions: _vm.actions },
            on: {
              "appliquer-action": function($event) {
                return _vm.executerAction($event)
              }
            }
          }),
          _vm.pageActive
            ? _c("div", { staticClass: "card" }, [
                _c("div", { staticClass: "card-body flex-start" }, [
                  _c("div", { staticClass: "form-group" }, [
                    _c("label", { attrs: { for: "txtNumBL" } }, [
                      _vm._v("Num. BL")
                    ]),
                    _c("input", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model.trim",
                          value: _vm.commandeFournisseur.numeroBL,
                          expression: "commandeFournisseur.numeroBL",
                          modifiers: { trim: true }
                        }
                      ],
                      staticClass: "container-fluid",
                      attrs: { type: "text", id: "txtNumBL" },
                      domProps: { value: _vm.commandeFournisseur.numeroBL },
                      on: {
                        input: [
                          function($event) {
                            if ($event.target.composing) {
                              return
                            }
                            _vm.$set(
                              _vm.commandeFournisseur,
                              "numeroBL",
                              $event.target.value.trim()
                            )
                          },
                          function($event) {
                            return _vm.actions.disable(
                              _vm.actions,
                              !_vm.commandeFournisseur.numeroBL ||
                                !_vm.commandeFournisseur.dateLivraison
                            )
                          }
                        ],
                        blur: function($event) {
                          return _vm.$forceUpdate()
                        }
                      }
                    }),
                    !_vm.$v.commandeFournisseur.numeroBL.required
                      ? _c("div", { staticClass: "error" }, [
                          _vm._v("Ce champ est requis")
                        ])
                      : _vm._e()
                  ]),
                  _c(
                    "div",
                    { staticClass: "form-group ml-2" },
                    [
                      _c("label", { attrs: { for: "dpDateLivraison" } }, [
                        _vm._v("Date de livraison")
                      ]),
                      _c("v-date-picker", {
                        staticClass: "date-picker",
                        attrs: {
                          id: "dpDateLivraison",
                          popover: { visibility: "click" }
                        },
                        on: {
                          input: function($event) {
                            return _vm.setDateLivraisonSCommande(
                              _vm.commandeFournisseur,
                              $event
                            )
                          }
                        },
                        scopedSlots: _vm._u(
                          [
                            {
                              key: "default",
                              fn: function(ref) {
                                var inputValue = ref.inputValue
                                var inputEvents = ref.inputEvents
                                return [
                                  _c(
                                    "input",
                                    _vm._g(
                                      {
                                        domProps: {
                                          value: inputValue
                                            ? inputValue
                                            : "Date de livraison..."
                                        }
                                      },
                                      inputEvents
                                    )
                                  )
                                ]
                              }
                            }
                          ],
                          null,
                          false,
                          1378568625
                        ),
                        model: {
                          value: _vm.commandeFournisseur.dateLivraison,
                          callback: function($$v) {
                            _vm.$set(
                              _vm.commandeFournisseur,
                              "dateLivraison",
                              $$v
                            )
                          },
                          expression: "commandeFournisseur.dateLivraison"
                        }
                      }),
                      !_vm.$v.commandeFournisseur.dateLivraison.required
                        ? _c("div", { staticClass: "error" }, [
                            _vm._v("Ce champ est requis")
                          ])
                        : _vm._e()
                    ],
                    1
                  )
                ])
              ])
            : _vm._e(),
          _vm.commandeFournisseur.raisonIncidentId
            ? _c("div", [
                _c(
                  "div",
                  {
                    staticClass: "alert alert-danger mb-1",
                    staticStyle: { padding: "2px" },
                    attrs: { role: "alert" }
                  },
                  [
                    _vm.pageActive
                      ? _c(
                          "button",
                          {
                            staticClass: "close",
                            attrs: {
                              type: "button",
                              "data-dismiss": "alert",
                              "aria-label": "Close"
                            },
                            on: {
                              click: function($event) {
                                return _vm.enleverIncident(
                                  _vm.commandeFournisseur
                                )
                              }
                            }
                          },
                          [
                            _c(
                              "span",
                              {
                                staticStyle: { "vertical-align": "middle" },
                                attrs: { "aria-hidden": "true" }
                              },
                              [_vm._v("×")]
                            )
                          ]
                        )
                      : _vm._e(),
                    _c("span", { staticStyle: { "padding-left": "10px" } }, [
                      _vm._v(
                        " " +
                          _vm._s(_vm.raisonIncident(_vm.commandeFournisseur)) +
                          " "
                      )
                    ])
                  ]
                )
              ])
            : _vm._e(),
          _c("div", { staticClass: "card table-scroll height-responsive-90" }, [
            _c(
              "div",
              { staticClass: "card-header flex-center-space-between" },
              [
                _c("div", { staticClass: "flex-start" }, [
                  _c("span", [
                    _vm._v(
                      _vm._s(_vm.commandeFournisseur.commandeNom) +
                        " - " +
                        _vm._s(
                          _vm.nomFournisseur(
                            _vm.commandeFournisseur.fournisseurId
                          )
                        )
                    )
                  ])
                ]),
                _c("div", { staticClass: "flex-end" }, [
                  !_vm.pageActive
                    ? _c("span", { staticClass: "ml-5" }, [
                        _vm._v(
                          "Num. BL : " +
                            _vm._s(_vm.commandeFournisseur.numeroBL)
                        )
                      ])
                    : _vm._e(),
                  !_vm.pageActive
                    ? _c("span", { staticClass: "ml-5" }, [
                        _vm._v(
                          "Date livraison : " +
                            _vm._s(
                              _vm.formatHumanDateAvecSlashes(
                                _vm.commandeFournisseur.dateLivraison
                              )
                            )
                        )
                      ])
                    : _vm._e(),
                  _vm.pageActive
                    ? _c("span", { staticClass: "ml-5" }, [
                        _vm._v(
                          "Num. BdC : " +
                            _vm._s(_vm.commandeFournisseur.bonDeCommande)
                        )
                      ])
                    : _vm._e(),
                  _vm.pageActive
                    ? _c("span", { staticClass: "ml-5" }, [
                        _vm._v(
                          "Nb lignes : " +
                            _vm._s(
                              _vm.fournisseurNbLignes(
                                _vm.commandeFournisseur.lignes
                              )
                            )
                        )
                      ])
                    : _vm._e(),
                  _vm.pageActive
                    ? _c("span", { staticClass: "ml-5" }, [
                        _vm._v(
                          "Total HT cmd : " +
                            _vm._s(
                              _vm._f("afficherPrix2")(
                                _vm.commandeFournisseur.totalHDT
                              )
                            )
                        )
                      ])
                    : _vm._e(),
                  _c("span", { staticClass: "ml-5" }, [
                    _vm._v(
                      "Total HT livré : " +
                        _vm._s(
                          _vm._f("afficherPrix2")(
                            _vm.fournisseurTotalLivre(
                              _vm.commandeFournisseur.lignes
                            )
                          )
                        )
                    )
                  ])
                ])
              ]
            ),
            _vm._m(0),
            _vm._m(1),
            _c("div", { staticClass: "table-body" }, [
              _c(
                "table",
                { staticClass: "table table-bordered table-sm text-center" },
                [
                  _vm._m(2),
                  _c(
                    "tbody",
                    _vm._l(_vm.commandeFournisseur.lignes, function(
                      ligne,
                      iLigne
                    ) {
                      return _c(
                        "tr",
                        {
                          key: iLigne,
                          class: [
                            {
                              "ligne-selectionnee":
                                _vm.idLignePourSelection(ligne) ===
                                _vm.idLigneSelectionnee
                            }
                          ],
                          on: {
                            click: function($event) {
                              return _vm.selectionnerLigneCommande(ligne)
                            }
                          }
                        },
                        [
                          _c(
                            "td",
                            {
                              class: [
                                { "ligne-supprimee": ligne.quantite === 0 }
                              ]
                            },
                            [
                              _c("div", { staticClass: "flex-space-between" }, [
                                _c("span", [
                                  ligne.ancienTarifId
                                    ? _c("span", [
                                        _c("del", [
                                          _vm._v(
                                            _vm._s(ligne.ancienneDesignation) +
                                              " " +
                                              _vm._s(
                                                ligne.ancienneReference
                                                  ? "(" +
                                                      ligne.ancienneReference +
                                                      ")"
                                                  : ""
                                              )
                                          )
                                        ]),
                                        _vm._v(
                                          " " +
                                            _vm._s(
                                              _vm.designation(
                                                _vm.commandeFournisseur
                                                  .fournisseurId,
                                                ligne.dAgap,
                                                ligne.dFou
                                              )
                                            ) +
                                            " " +
                                            _vm._s(
                                              ligne.reference
                                                ? "(" + ligne.reference + ")"
                                                : ""
                                            ) +
                                            " "
                                        )
                                      ])
                                    : ligne.tIdLivre
                                    ? _c("span", [
                                        ligne.tIdLivre !== ligne.tId &&
                                        (ligne.refLivree !== ligne.reference ||
                                          ligne.designationLivree !==
                                            _vm.designation(
                                              ligne.foId,
                                              ligne.dAgap,
                                              ligne.dFou
                                            ))
                                          ? _c("del", [
                                              _vm._v(
                                                " " +
                                                  _vm._s(
                                                    _vm.designation(
                                                      _vm.commandeFournisseur
                                                        .fournisseurId,
                                                      ligne.dAgap,
                                                      ligne.dFou
                                                    )
                                                  ) +
                                                  " " +
                                                  _vm._s(
                                                    ligne.reference
                                                      ? "(" +
                                                          ligne.reference +
                                                          ")"
                                                      : ""
                                                  ) +
                                                  " "
                                              )
                                            ])
                                          : _vm._e(),
                                        _vm._v(
                                          " " +
                                            _vm._s(ligne.designationLivree) +
                                            " " +
                                            _vm._s(
                                              ligne.refLivree
                                                ? "(" + ligne.refLivree + ")"
                                                : ""
                                            ) +
                                            " "
                                        )
                                      ])
                                    : _c("span", [
                                        _vm._v(
                                          " " +
                                            _vm._s(
                                              _vm.designation(
                                                _vm.commandeFournisseur
                                                  .fournisseurId,
                                                ligne.dAgap,
                                                ligne.dFou
                                              )
                                            ) +
                                            " " +
                                            _vm._s(
                                              ligne.reference
                                                ? "(" + ligne.reference + ")"
                                                : ""
                                            ) +
                                            " "
                                        )
                                      ])
                                ]),
                                _vm.pageActive
                                  ? _c(
                                      "span",
                                      [
                                        ligne.id
                                          ? _c("RechercheAjoutProduit", {
                                              attrs: {
                                                fournisseurId:
                                                  _vm.commandeFournisseur
                                                    .fournisseurId
                                              },
                                              on: {
                                                "substituer-article": function(
                                                  $event
                                                ) {
                                                  return _vm.substituerArticle(
                                                    ligne,
                                                    $event
                                                  )
                                                }
                                              }
                                            })
                                          : _c(
                                              "button",
                                              {
                                                staticClass:
                                                  "btn btn-primary btn-sm",
                                                attrs: { size: "sm" },
                                                on: {
                                                  click: function($event) {
                                                    return _vm.retirerArticle(
                                                      _vm.commandeFournisseur,
                                                      iLigne
                                                    )
                                                  }
                                                }
                                              },
                                              [
                                                _c("i", {
                                                  staticClass: "fas fa-minus"
                                                })
                                              ]
                                            )
                                      ],
                                      1
                                    )
                                  : _vm._e()
                              ])
                            ]
                          ),
                          _c(
                            "td",
                            {
                              class: [
                                "col-fixed-width-150-sm",
                                "col-fixed-width-250-lg",
                                "col-fixed-width-350-xl",
                                { "alert-danger": ligne.raisonIncidentId }
                              ]
                            },
                            [
                              _c("div", { staticClass: "flex-end" }, [
                                ligne.raisonIncidentId
                                  ? _c("div", [
                                      _vm._v(
                                        " " +
                                          _vm._s(_vm.raisonIncident(ligne)) +
                                          " "
                                      )
                                    ])
                                  : _vm._e(),
                                _vm.pageActive
                                  ? _c("span", [
                                      ligne.raisonIncidentId
                                        ? _c(
                                            "button",
                                            {
                                              staticClass:
                                                "btn btn-primary btn-sm",
                                              attrs: { size: "sm" },
                                              on: {
                                                click: function($event) {
                                                  return _vm.enleverIncident(
                                                    ligne
                                                  )
                                                }
                                              }
                                            },
                                            [
                                              _c("i", {
                                                staticClass: "fas fa-minus"
                                              })
                                            ]
                                          )
                                        : _c(
                                            "button",
                                            {
                                              staticClass:
                                                "btn btn-primary btn-sm",
                                              attrs: { size: "sm" },
                                              on: {
                                                click: function($event) {
                                                  return _vm.ouvrirAjoutIncidentLigne(
                                                    ligne
                                                  )
                                                }
                                              }
                                            },
                                            [
                                              _c("i", {
                                                staticClass:
                                                  "fas fa-exclamation-triangle"
                                              })
                                            ]
                                          )
                                    ])
                                  : _vm._e()
                              ])
                            ]
                          ),
                          _c(
                            "td",
                            {
                              class: [
                                { "ligne-supprimee": ligne.quantite === 0 }
                              ]
                            },
                            [
                              _c("div", [
                                _vm._v(
                                  _vm._s(ligne.qPCB) + " " + _vm._s(ligne.uc)
                                )
                              ])
                            ]
                          ),
                          _c(
                            "td",
                            {
                              class: [
                                { "ligne-supprimee": ligne.quantite === 0 },
                                {
                                  "alert-danger": ligne.quantite !== ligne.qPCB
                                }
                              ]
                            },
                            [
                              ligne.estLivree
                                ? _c("div", [
                                    _vm._v(
                                      _vm._s(ligne.qteLivree) +
                                        " " +
                                        _vm._s(ligne.uc)
                                    )
                                  ])
                                : _c(
                                    "div",
                                    { staticClass: "flex-end" },
                                    [
                                      _c("InputNumber", {
                                        key: "quantite" + ligne.foId,
                                        attrs: {
                                          id:
                                            "qteLivree" +
                                            _vm.idLignePourSelection(ligne),
                                          step: "0.001",
                                          typeFiltre: "quantite",
                                          zeroSiVide: "1"
                                        },
                                        on: {
                                          focus: function($event) {
                                            return _vm.selectionnerLigneCommande(
                                              ligne
                                            )
                                          },
                                          move: function($event) {
                                            return _vm.deplacerQteLivree($event)
                                          }
                                        },
                                        model: {
                                          value: ligne.quantite,
                                          callback: function($$v) {
                                            _vm.$set(ligne, "quantite", $$v)
                                          },
                                          expression: "ligne.quantite"
                                        }
                                      }),
                                      _c(
                                        "span",
                                        { staticClass: "input-group-text" },
                                        [_vm._v(_vm._s(ligne.uc))]
                                      )
                                    ],
                                    1
                                  )
                            ]
                          ),
                          _c(
                            "td",
                            {
                              class: [
                                { "ligne-supprimee": ligne.quantite === 0 }
                              ]
                            },
                            [
                              _c("div", [
                                _vm._v(_vm._s(_vm._f("afficherPrix")(ligne.pu)))
                              ])
                            ]
                          ),
                          _c(
                            "td",
                            {
                              class: [
                                { "ligne-supprimee": ligne.quantite === 0 },
                                {
                                  "alert-danger":
                                    ligne.puLivre.toFixed(3) >
                                    ligne.pu.toFixed(3),
                                  "alert-success":
                                    ligne.puLivre.toFixed(3) <
                                    ligne.pu.toFixed(3)
                                }
                              ]
                            },
                            [
                              ligne.estLivree
                                ? _c("div", [
                                    _vm._v(
                                      _vm._s(
                                        _vm._f("afficherPrix")(ligne.puLivre)
                                      )
                                    )
                                  ])
                                : _c(
                                    "div",
                                    { staticClass: "flex-end" },
                                    [
                                      _c("InputNumber", {
                                        key: "pu" + ligne.foId,
                                        attrs: {
                                          id:
                                            "puLivre" +
                                            _vm.idLignePourSelection(ligne),
                                          typeFiltre: "quantite",
                                          step: "0.001",
                                          zeroSiVide: "1"
                                        },
                                        on: {
                                          focus: function($event) {
                                            return _vm.selectionnerLigneCommande(
                                              ligne
                                            )
                                          },
                                          move: function($event) {
                                            return _vm.deplacerPULivre($event)
                                          }
                                        },
                                        model: {
                                          value: ligne.puLivre,
                                          callback: function($$v) {
                                            _vm.$set(ligne, "puLivre", $$v)
                                          },
                                          expression: "ligne.puLivre"
                                        }
                                      }),
                                      _c(
                                        "span",
                                        { staticClass: "input-group-text" },
                                        [_vm._v("€")]
                                      )
                                    ],
                                    1
                                  )
                            ]
                          ),
                          _c(
                            "td",
                            {
                              class: [
                                { "ligne-supprimee": ligne.quantite === 0 }
                              ]
                            },
                            [
                              _c("div", [
                                _vm._v(
                                  _vm._s(
                                    _vm._f("afficherPrix2")(
                                      _vm.ligneTotalPCBCommande(ligne)
                                    )
                                  )
                                )
                              ])
                            ]
                          ),
                          _c(
                            "td",
                            {
                              class: [
                                { "ligne-supprimee": ligne.quantite === 0 },
                                {
                                  "alert-danger":
                                    _vm.arrondiNombre(ligne.quantite, 2) <
                                      _vm.arrondiNombre(ligne.qDem, 2) ||
                                    _vm.arrondiNombre(ligne.puLivre, 3) >
                                      _vm.arrondiNombre(ligne.pu, 3),
                                  "alert-success":
                                    _vm.arrondiNombre(ligne.puLivre, 3) <
                                    _vm.arrondiNombre(ligne.pu, 3)
                                }
                              ]
                            },
                            [
                              _vm._v(
                                " " +
                                  _vm._s(
                                    _vm._f("afficherPrix2")(
                                      _vm.ligneTotalLivre(ligne)
                                    )
                                  ) +
                                  " "
                              )
                            ]
                          ),
                          !ligne.lots || !ligne.lots.length
                            ? _c("td")
                            : _vm._e(),
                          !ligne.lots || !ligne.lots.length
                            ? _c("td")
                            : _vm._e(),
                          !ligne.lots || !ligne.lots.length
                            ? _c("td")
                            : _vm._e(),
                          !ligne.lots || !ligne.lots.length
                            ? _c("td")
                            : _vm._e(),
                          !ligne.lots || !ligne.lots.length
                            ? _c("td")
                            : _c(
                                "td",
                                {
                                  staticClass: "td-table",
                                  attrs: { colspan: "5" }
                                },
                                [
                                  _c(
                                    "table",
                                    {
                                      staticClass:
                                        "table table-bordered table-sm text-center"
                                    },
                                    [
                                      _vm._m(3, true),
                                      _c(
                                        "tbody",
                                        _vm._l(ligne.lots, function(lot, iLot) {
                                          return _c(
                                            "tr",
                                            {
                                              key: iLot,
                                              class: [
                                                {
                                                  "ligne-supprimee":
                                                    ligne.quantite === 0
                                                }
                                              ]
                                            },
                                            [
                                              _c(
                                                "td",
                                                { staticClass: "input" },
                                                [
                                                  ligne.estLivree
                                                    ? _c("div", [
                                                        _vm._v(
                                                          _vm._s(lot.quantite)
                                                        )
                                                      ])
                                                    : _c(
                                                        "div",
                                                        [
                                                          _c("InputNumber", {
                                                            attrs: {
                                                              typeFiltre:
                                                                "quantite",
                                                              zeroSiVide: "1"
                                                            },
                                                            model: {
                                                              value:
                                                                lot.quantite,
                                                              callback: function(
                                                                $$v
                                                              ) {
                                                                _vm.$set(
                                                                  lot,
                                                                  "quantite",
                                                                  $$v
                                                                )
                                                              },
                                                              expression:
                                                                "lot.quantite"
                                                            }
                                                          })
                                                        ],
                                                        1
                                                      )
                                                ]
                                              ),
                                              _c(
                                                "td",
                                                { staticClass: "input" },
                                                [
                                                  ligne.estLivree
                                                    ? _c("div", [
                                                        _vm._v(
                                                          _vm._s(lot.numero)
                                                        )
                                                      ])
                                                    : _c("div", [
                                                        _c("input", {
                                                          directives: [
                                                            {
                                                              name: "model",
                                                              rawName:
                                                                "v-model",
                                                              value: lot.numero,
                                                              expression:
                                                                "lot.numero"
                                                            }
                                                          ],
                                                          staticStyle: {
                                                            width: "100%"
                                                          },
                                                          attrs: {
                                                            type: "text"
                                                          },
                                                          domProps: {
                                                            value: lot.numero
                                                          },
                                                          on: {
                                                            input: function(
                                                              $event
                                                            ) {
                                                              if (
                                                                $event.target
                                                                  .composing
                                                              ) {
                                                                return
                                                              }
                                                              _vm.$set(
                                                                lot,
                                                                "numero",
                                                                $event.target
                                                                  .value
                                                              )
                                                            }
                                                          }
                                                        })
                                                      ])
                                                ]
                                              ),
                                              _c(
                                                "td",
                                                { staticClass: "input" },
                                                [
                                                  ligne.estLivree
                                                    ? _c(
                                                        "div",
                                                        {
                                                          attrs: {
                                                            title:
                                                              !lot.dlc &&
                                                              "Date de Durabilité Minimale"
                                                          }
                                                        },
                                                        [
                                                          _vm._v(
                                                            _vm._s(
                                                              lot.dlc
                                                                ? "DLC"
                                                                : "DDM"
                                                            )
                                                          )
                                                        ]
                                                      )
                                                    : _c("div", [
                                                        _c("input", {
                                                          directives: [
                                                            {
                                                              name: "model",
                                                              rawName:
                                                                "v-model",
                                                              value: lot.dlc,
                                                              expression:
                                                                "lot.dlc"
                                                            }
                                                          ],
                                                          attrs: {
                                                            type: "checkbox"
                                                          },
                                                          domProps: {
                                                            checked: Array.isArray(
                                                              lot.dlc
                                                            )
                                                              ? _vm._i(
                                                                  lot.dlc,
                                                                  null
                                                                ) > -1
                                                              : lot.dlc
                                                          },
                                                          on: {
                                                            change: function(
                                                              $event
                                                            ) {
                                                              var $$a = lot.dlc,
                                                                $$el =
                                                                  $event.target,
                                                                $$c = $$el.checked
                                                                  ? true
                                                                  : false
                                                              if (
                                                                Array.isArray(
                                                                  $$a
                                                                )
                                                              ) {
                                                                var $$v = null,
                                                                  $$i = _vm._i(
                                                                    $$a,
                                                                    $$v
                                                                  )
                                                                if (
                                                                  $$el.checked
                                                                ) {
                                                                  $$i < 0 &&
                                                                    _vm.$set(
                                                                      lot,
                                                                      "dlc",
                                                                      $$a.concat(
                                                                        [$$v]
                                                                      )
                                                                    )
                                                                } else {
                                                                  $$i > -1 &&
                                                                    _vm.$set(
                                                                      lot,
                                                                      "dlc",
                                                                      $$a
                                                                        .slice(
                                                                          0,
                                                                          $$i
                                                                        )
                                                                        .concat(
                                                                          $$a.slice(
                                                                            $$i +
                                                                              1
                                                                          )
                                                                        )
                                                                    )
                                                                }
                                                              } else {
                                                                _vm.$set(
                                                                  lot,
                                                                  "dlc",
                                                                  $$c
                                                                )
                                                              }
                                                            }
                                                          }
                                                        })
                                                      ])
                                                ]
                                              ),
                                              _c(
                                                "td",
                                                { staticClass: "input" },
                                                [
                                                  ligne.estLivree
                                                    ? _c("div", [
                                                        _vm._v(
                                                          _vm._s(
                                                            _vm.formatHumanDate(
                                                              lot.dlcDluo
                                                            )
                                                          )
                                                        )
                                                      ])
                                                    : _c(
                                                        "div",
                                                        [
                                                          _c("v-date-picker", {
                                                            staticClass:
                                                              "date-picker",
                                                            attrs: {
                                                              popover: {
                                                                visibility:
                                                                  "click"
                                                              }
                                                            },
                                                            scopedSlots: _vm._u(
                                                              [
                                                                {
                                                                  key:
                                                                    "default",
                                                                  fn: function(
                                                                    ref
                                                                  ) {
                                                                    var inputValue =
                                                                      ref.inputValue
                                                                    var inputEvents =
                                                                      ref.inputEvents
                                                                    return [
                                                                      _c(
                                                                        "input",
                                                                        _vm._g(
                                                                          {
                                                                            domProps: {
                                                                              value: inputValue
                                                                                ? inputValue
                                                                                : "Choisir la date..."
                                                                            }
                                                                          },
                                                                          inputEvents
                                                                        )
                                                                      )
                                                                    ]
                                                                  }
                                                                }
                                                              ],
                                                              null,
                                                              true
                                                            ),
                                                            model: {
                                                              value:
                                                                lot.dlcDluo,
                                                              callback: function(
                                                                $$v
                                                              ) {
                                                                _vm.$set(
                                                                  lot,
                                                                  "dlcDluo",
                                                                  $$v
                                                                )
                                                              },
                                                              expression:
                                                                "lot.dlcDluo"
                                                            }
                                                          })
                                                        ],
                                                        1
                                                      )
                                                ]
                                              ),
                                              _c(
                                                "td",
                                                { staticClass: "input" },
                                                [
                                                  _vm.pageActive
                                                    ? _c(
                                                        "button",
                                                        {
                                                          staticClass:
                                                            "btn btn-primary btn-sm",
                                                          attrs: { size: "sm" },
                                                          on: {
                                                            click: function(
                                                              $event
                                                            ) {
                                                              return _vm.supprimerLigneLot(
                                                                ligne.lots,
                                                                iLot
                                                              )
                                                            }
                                                          }
                                                        },
                                                        [
                                                          _c("i", {
                                                            staticClass:
                                                              "fas fa-minus"
                                                          })
                                                        ]
                                                      )
                                                    : _vm._e()
                                                ]
                                              )
                                            ]
                                          )
                                        }),
                                        0
                                      )
                                    ]
                                  )
                                ]
                              ),
                          _c("td", { staticClass: "input" }, [
                            _vm.pageActive
                              ? _c(
                                  "button",
                                  {
                                    staticClass: "btn btn-primary btn-sm",
                                    attrs: { size: "sm" },
                                    on: {
                                      click: function($event) {
                                        return _vm.ajouterLot(ligne)
                                      }
                                    }
                                  },
                                  [_c("i", { staticClass: "fas fa-plus" })]
                                )
                              : _vm._e()
                          ])
                        ]
                      )
                    }),
                    0
                  )
                ]
              )
            ])
          ])
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "table",
      {
        staticClass:
          "table table-bordered table-sm text-center table-header-secondary"
      },
      [
        _c("colgroup", [
          _c("col"),
          _c("col"),
          _c("col", { attrs: { width: "190" } }),
          _c("col", { attrs: { width: "190" } }),
          _c("col", { attrs: { width: "190" } }),
          _c("col", { attrs: { width: "345" } })
        ]),
        _c("thead", [
          _c("th", { staticClass: "aligner-gauche" }, [
            _vm._v("Désignation (Réf.)")
          ]),
          _c(
            "th",
            {
              staticClass:
                "col-fixed-width-150-sm col-fixed-width-250-lg col-fixed-width-350-xl"
            },
            [_vm._v("Raison incident")]
          ),
          _c("th", [_vm._v("Quantité")]),
          _c("th", [_vm._v("Prix")]),
          _c("th", [_vm._v("Total")]),
          _c("th", [_vm._v("Lots")])
        ])
      ]
    )
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "table",
      {
        staticClass:
          "table table-bordered table-sm text-center table-header-secondary"
      },
      [
        _c("colgroup", [
          _c("col"),
          _c("col"),
          _c("col", { attrs: { width: "95" } }),
          _c("col", { attrs: { width: "95" } }),
          _c("col", { attrs: { width: "95" } }),
          _c("col", { attrs: { width: "95" } }),
          _c("col", { attrs: { width: "95" } }),
          _c("col", { attrs: { width: "95" } }),
          _c("col", { attrs: { width: "50" } }),
          _c("col", { attrs: { width: "80" } }),
          _c("col", { attrs: { width: "50" } }),
          _c("col", { attrs: { width: "100" } }),
          _c("col", { attrs: { width: "30" } }),
          _c("col", { attrs: { width: "35" } })
        ]),
        _c("thead", [
          _c("th"),
          _c("th", {
            staticClass:
              "col-fixed-width-150-sm col-fixed-width-250-lg col-fixed-width-350-xl"
          }),
          _c("th", [_vm._v("Commandée")]),
          _c("th", [_vm._v("Livrée")]),
          _c("th", [_vm._v("Commandé")]),
          _c("th", [_vm._v("Livré")]),
          _c("th", [_vm._v("Commandé")]),
          _c("th", [_vm._v("Livré")]),
          _c("th", [_vm._v("Qté")]),
          _c("th", [_vm._v("N°")]),
          _c("th", [_vm._v("DLC")]),
          _c("th", [_vm._v("DLC/DDM")]),
          _c("th"),
          _c("th")
        ])
      ]
    )
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("colgroup", [
      _c("col"),
      _c("col"),
      _c("col", { attrs: { width: "95" } }),
      _c("col", { attrs: { width: "95" } }),
      _c("col", { attrs: { width: "95" } }),
      _c("col", { attrs: { width: "95" } }),
      _c("col", { attrs: { width: "95" } }),
      _c("col", { attrs: { width: "95" } }),
      _c("col", { attrs: { width: "50" } }),
      _c("col", { attrs: { width: "80" } }),
      _c("col", { attrs: { width: "50" } }),
      _c("col", { attrs: { width: "100" } }),
      _c("col", { attrs: { width: "30" } }),
      _c("col", { attrs: { width: "30" } })
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("colgroup", [
      _c("col", { attrs: { width: "49" } }),
      _c("col", { attrs: { width: "80" } }),
      _c("col", { attrs: { width: "50" } }),
      _c("col", { attrs: { width: "100" } }),
      _c("col", { attrs: { width: "29" } })
    ])
  }
]
render._withStripped = true

export { render, staticRenderFns }